import { useLocation } from 'react-router-dom';
import React from 'react';
export var useSearchParams = function () {
    var search = useLocation().search;
    return React.useMemo(function () { return new URLSearchParams(search); }, [search]);
};
